<carousel [showActions]="true" [enableHover]="false" [showSelection]="true" [dataSource]="rooms()" class="carousel">
    <span carousel-label>Assign Room Content To ({{rooms().length}})</span>

    <div class="d-flex gap-3" carousel-action>
        <is-busy-button id="apply-button" (execute)="cancelAssignment()" [disabled]="false"
            [css]="'btn d-flex align-items-center gap-2 w-100 clip3 corner position-relative primary-border primary-bg primary-text-100 font-4 rounded-0 py-2'">
            <svg-icon key="remove"></svg-icon>
            <span>Cancel</span>
        </is-busy-button>
        <is-busy-button id="apply-button" (execute)="applyAssignment()"
            [css]="'btn d-flex align-items-center gap-2 w-100 clip3 corner position-relative primary-border secondary-bg secondary-text-100 font-4 rounded-0 py-2'">
            <svg-icon key="tick"></svg-icon>
            <span>Apply</span>
        </is-busy-button>
    </div>
</carousel>


<carousel [showSelection]="true" [enableHover]="false" [dataSource]="roomContents()" class="carousel">
    <span carousel-label>Assigned Room Content ({{roomContents().length}})</span>
</carousel>

<div class="horizontal-line mt-5"></div>

<carousel [showSelection]="true" [enableHover]="false" [dataSource]="roomContents()" class="carousel">
    <span carousel-label>Room Content ({{roomContents().length}})</span>
</carousel>